export default __webpack_public_path__ + "static/3-249d386903a70a5fc674bd9173a7f098.jpg";